var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 15.71a.3.3 0 1 0-.59 0 10.21 10.21 0 0 0 .21 5.08.33.33 0 0 0 .66-.1c0-.84.1-2 0-3-.05-.69-.18-1.31-.28-1.98Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61 15.63a.3.3 0 0 0-.59 0 13.48 13.48 0 0 0-.16 5.17.34.34 0 1 0 .67 0 12.73 12.73 0 0 0 .08-5.17Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.61 12.94a150.11 150.11 0 0 0-15.28.12.3.3 0 0 0 .07.59 11.93 11.93 0 0 1 1.89 0 22.74 22.74 0 0 0 .09 3.08 16.64 16.64 0 0 0 .43 4.05A4.27 4.27 0 0 0 8 23.24c1.3.94 3.06.78 4.64.7 1.17-.07 2.56.09 3.48-.81S17 21.08 17.23 20a50 50 0 0 0 1.16-6.38l1.19 0a.34.34 0 1 0 .03-.68Zm-3.32 6.88c-.2.85-.3 2-.9 2.53s-2 .41-2.8.45c-4.42.24-4.22-.52-4.85-2.3a15.8 15.8 0 0 1-.61-3.81 22 22 0 0 1-.24-3 60.24 60.24 0 0 0 10.8-.06 50.57 50.57 0 0 1-1.4 6.19Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09 11.49c.63.23 1.12-.14 1.28-.12.68.1 1.48.88 2.51.36.43-.21.64-.49.82-.5.73-.05 1.43.67 2.4.15 1.45-.79 1.37-1.74 1-3.2a2.88 2.88 0 0 0-1-1.87c-1.06-.67-1.89 0-2.72-.35a.34.34 0 0 0-.26.63c.83.36 1.83-.11 2.53.39.38.27.5 1 .59 1.4.22 1.09.37 1.58-.6 2-.41.2-1.3-.36-2-.33s-.9.57-1.38.65-1.14-.41-1.75-.48a1.41 1.41 0 0 0-.78.14.41.41 0 0 1-.29.07c-1.07-.33-.63-1.58-.11-2.61l.21-.73a2.31 2.31 0 0 1 2.14-.28.3.3 0 1 0 .14-.58A2.93 2.93 0 0 0 9 6.6c-.25.24-.27.67-.39.87-.96 1.63-1.3 3.35.48 4.02Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.12 8.13a3 3 0 0 0-.4.39c-.06.09 0 .17 0 .25s.12.27.35.4 0-.21 1 .29a1.4 1.4 0 0 0 1.52 0 .34.34 0 0 0-.27-.62c-.36.09-.55-.25-.65-.33-.35-.19-1.36-.69-1.55-.38Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4A13.38 13.38 0 0 1 19.33.67a.33.33 0 1 0-.11-.67 6.6 6.6 0 0 0-5.69 3.61A.3.3 0 1 0 14 4Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 2.93a3.28 3.28 0 0 0-2.54 1.76.3.3 0 0 0 .41.44 8.45 8.45 0 0 0 1.59-.93c.28-.21.52-.45.81-.65a.34.34 0 0 0-.27-.62Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodWaste);
export default __webpack_public_path__ + "static/media/food-waste.611859bd33b8a8f9e75c46d2b86d83d0.svg";
export { ForwardRef as ReactComponent };